import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class FilterRow extends DomainObject {
  attribute;
  operator;

  constructor(other) {
    super();

    makeObservable(this, {
      attribute: observable,
      operator: observable
    });

    this.merge(other);
  }
}

export default FilterRow;
